var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "grid",
      style: [_vm.displayGridGap, _vm.displayGridColumns],
    },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "grid-item",
          class: _vm.displayGridItemClass,
        },
        [_vm._t("item", null, { item: { ...item, index } })],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }